import { Component, OnInit } from "@angular/core";
import { AngularFireStorage, BUCKET } from "@angular/fire/storage";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: [],
  providers: [{ provide: BUCKET, useValue: "rise-as-one-website.appspot.com" }],
})
export class HomeComponent implements OnInit {
  images = [];

  ngOnInit() {
    this.images.push(
      this.firestorage.ref("/rise-as-one-images/DSC_0005.JPG").getDownloadURL()
    );
    this.images.push(
      this.firestorage.ref("/rise-as-one-images/DSC_0006.JPG").getDownloadURL()
    );
    this.images.push(
      this.firestorage.ref("/rise-as-one-images/DSC_0009.JPG").getDownloadURL()
    );
  }

  constructor(private firestorage: AngularFireStorage) {}
}
